import { render } from "./AppHeader.vue?vue&type=template&id=8b3d0b70&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=8b3d0b70&scoped=true&lang=css"
import "./AppHeader.vue?vue&type=style&index=1&id=8b3d0b70&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3d0b70"]])

export default __exports__